'use strict';

module.exports = {
  getPeaksAnnotation: require('./getPeaksAnnotation')
};
